import { render } from "./OrganizationSecuritySettings.vue?vue&type=template&id=8b980eae&scoped=true"
import script from "./OrganizationSecuritySettings.vue?vue&type=script&lang=js"
export * from "./OrganizationSecuritySettings.vue?vue&type=script&lang=js"

import "./OrganizationSecuritySettings.vue?vue&type=style&index=0&id=8b980eae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b980eae"]])

export default __exports__